import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { QueryParamsProvider as Component } from './query-params-provider';
import type { IProps } from './models';

export const QueryParamsProvider = createWidget<unknown, IProps>()(Component);
